//pattern
import { Component } from '@angular/core';
import { Message } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Store } from '@ngrx/store';

//form
import { DadosReceitasFormComponent } from '../dados-receitas-form/dados-receitas-form.component';
import { IRevenueState } from 'src/app/store/revenue/revenue.reducer';
import {
  activateRevenue,
  inactivateRevenue,
  loadRevenue,
} from 'src/app/store/revenue/revenue.actions';
import { selectRevenueLista, selectRevenueLoading } from 'src/app/store/revenue/revenue.selectors';
import { map } from 'rxjs';

@Component({
  selector: 'app-dados-receitas',
  templateUrl: './dados-receitas.component.html',
  styleUrls: ['./dados-receitas.component.scss'],
})
export class DadosReceitasComponent {
mostrarModalInativarReceitas = false
mostrarModalAtivar = false
selectedRevenue: number = 9999999999

isLoading$ = this.store.select(selectRevenueLoading)
  messages: Message[] = [
    {
      severity: 'warn',
      summary: '',
      detail:
        'Preencha essas informações pela primeira vez e salve as suas preferências. ',
    },
  ];

  constructor(
    public dialogService: DialogService,
    private store: Store<IRevenueState>
  ) {}

  ngOnInit(): void {
    this.store.dispatch(loadRevenue());
  }
  lista$ = this.store
    .select(selectRevenueLista)
    .pipe(map((res) => res/*.filter((item) => item.status == true)*/));

  ref: DynamicDialogRef | undefined;

  public showForm() {
    this.ref = this.dialogService.open(DadosReceitasFormComponent, {
      header: 'Receitas Categorias',
      dismissableMask: true,
      width: '45%',
      contentStyle: { overflow: 'auto' },
      baseZIndex: 10000,
    });
  }

  disableRevenue(id: number){
    this.mostrarModalInativarReceitas = true
    this.selectedRevenue = id
  }

  disableCard() {
    this.store.dispatch(inactivateRevenue({ id: this.selectedRevenue }));
    this.fecharDialog()
  }

  public fecharDialog() {
    this.ref?.destroy()

    this.mostrarModalInativarReceitas = false
    this.mostrarModalAtivar = false
  }

  enableRevenue(id: number){
    this.mostrarModalAtivar = true
    this.selectedRevenue = id
  }

  enableCard() {
    this.store.dispatch(activateRevenue({ id: this.selectedRevenue }));
    this.fecharDialog()
  }
}
